let stickyHeaderInstance = null;

export function setupStickyHeader(options = {}) {
    const defaults = {
        tableSelector: '.table-sticky',
        navbarHeight: 66,
        offsetTop: 0,
        wrapperId: 'sticky-thead-wrapper',
    };

    const config = { ...defaults, ...options };
    const table = document.querySelector(config.tableSelector);
    if (!table) return;

    const tableContainer = table.closest('.table-responsive');
    const thead = table.querySelector('thead');
    if (!thead) return;

    let stickyContainer = null;
    let isSticky = false;

    function scrollToTop() {
        const tableTop = tableContainer.getBoundingClientRect().top + window.scrollY - config.navbarHeight;
        window.scrollTo({
            top: tableTop,
            behavior: 'smooth'
        });
    }

    function createStickyThead() {
        destroyStickyThead();

        stickyContainer = document.createElement('div');
        stickyContainer.id = config.wrapperId;
        stickyContainer.style.position = 'fixed';
        stickyContainer.style.top = `${config.navbarHeight}px`;
        stickyContainer.style.left = `${tableContainer.getBoundingClientRect().left}px`;
        stickyContainer.style.zIndex = '1000';
        stickyContainer.style.backgroundColor = 'white';
        stickyContainer.style.boxShadow = '0 2px 4px rgba(0,0,0,0.1)';
        stickyContainer.style.width = `${tableContainer.offsetWidth}px`;
        stickyContainer.style.overflow = 'hidden';

        const clonedThead = document.createElement('table');
        clonedThead.className = table.className;
        clonedThead.style.margin = '0';
        clonedThead.style.borderCollapse = 'collapse';
        clonedThead.style.width = `${table.offsetWidth}px`;

        const theadClone = thead.cloneNode(true);
        clonedThead.appendChild(theadClone);
        stickyContainer.appendChild(clonedThead);
        document.body.appendChild(stickyContainer);

        const origThs = thead.querySelectorAll('th');
        const cloneThs = theadClone.querySelectorAll('th');
        origThs.forEach((th, i) => {
            cloneThs[i].style.width = `${th.offsetWidth}px`;
            cloneThs[i].style.boxSizing = 'border-box';
            cloneThs[i].style.whiteSpace = 'nowrap';

            cloneThs[i].addEventListener('click', (e) => {
                e.preventDefault();

                scrollToTop();

                setTimeout(() => {
                    th.dispatchEvent(new MouseEvent('click', { bubbles: true }));
                }, 100);
            });
        });

        isSticky = true;
    }

    function destroyStickyThead() {
        if (stickyContainer) {
            stickyContainer.remove();
            stickyContainer = null;
        }
        isSticky = false;
    }

    function updateStickyHeader() {
        if (!tableContainer) return;

        const scrollTop = window.scrollY;
        const tableRect = tableContainer.getBoundingClientRect();
        const theadOffsetTop = tableRect.top + scrollTop;

        if (scrollTop > theadOffsetTop - config.navbarHeight && !isSticky) {
            createStickyThead();
        } else if (scrollTop <= theadOffsetTop - config.navbarHeight && isSticky) {
            destroyStickyThead();
        }

        if (isSticky && stickyContainer) {
            stickyContainer.style.left = `${tableRect.left}px`;
            stickyContainer.style.width = `${tableRect.width}px`;

            stickyContainer.querySelector('table').style.marginLeft = `-${tableContainer.scrollLeft}px`;
        }
    }

    function handleResize() {
        if (isSticky) {
            destroyStickyThead();
            createStickyThead();
        }
        updateStickyHeader();
    }

    function handleScroll() {
        updateStickyHeader();
    }

    window.addEventListener('scroll', updateStickyHeader);
    window.addEventListener('resize', handleResize);

    if (tableContainer) {
        tableContainer.addEventListener('scroll', handleScroll);
    }

    updateStickyHeader();

    return {
        destroy: () => {
            window.removeEventListener('scroll', updateStickyHeader);
            window.removeEventListener('resize', handleResize);
            if (tableContainer) {
                tableContainer.removeEventListener('scroll', handleScroll);
            }
            destroyStickyThead();
        }
    };
}

export function initStickyHeaders() {
    document.addEventListener('DOMContentLoaded', () => {
        if (stickyHeaderInstance) stickyHeaderInstance.destroy();
        stickyHeaderInstance = setupStickyHeader();
    });

    if (typeof Livewire !== 'undefined') {
        Livewire.hook('message.processed', () => {
            if (stickyHeaderInstance) stickyHeaderInstance.destroy();
            stickyHeaderInstance = setupStickyHeader();
        });
    }
}